module.exports = __webpack_public_path__ + "img/Spider Monitor_old.5eab6d07.svg";